import AppFeeDetailsSection from './AppFeeDetailsSection';
import { AppFeeDetailsSectionProps, AppFeeDetailsSectionValueProps } from './types';

export type { AppFeeDetailsSectionProps, AppFeeDetailsSectionValueProps };
export default AppFeeDetailsSection;
